import React, { useEffect, useState } from "react";
import "./Contact_Us.css";
import { Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Blue_Round_Btn from "../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import Explore_btn from "../common-components/common-buttons/explore-button/Explore_btn";
import Newslater from "../home/newslater/Newslater";
import Success_Modal from "../common-components/common-modals/success_modal/Success_Modal";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { contactusForm } from "../../features/contact_us/contactusSlice";
import MapComponent from "./map";
import { appSetup } from "../../features/master/masterSlice";
import Chat_Bot from "../product-description/chat-bot/Chat_Bot";
import Chat_Bot_Contact from "../product-description/chat-bot/Chat_Bot_Contact";

const Contact_Us = () => {
  const appsetup = useSelector((state) => state.master.app_setup);
    const product = useSelector((state) => state.product.product);
  const data = [
    {
      icon: "/assets/images/contact_us/location.png",
      title: "Bapat Optics",
      descn:
        "Shop no 2, Casablanca Opp. Karishma Society, Late GA Kulkarni Path, next to Kasat Exclusive, Kothrud, Pune, Maharashtra 411038",
    },
    {
      icon: "/assets/images/contact_us/location.png",
      title: "Bapat Optics",
      descn:
        "Shop No. 2, Mulay Arcade, Survey No 1537, Sadashiv Peth Rd, Sadashiv Peth, Pune, Maharashtra 411030",
    },
    {
      icon: "/assets/images/contact_us/mail.png",
      title: "How can we help?",
      descn: appsetup?.email,
    },
    {
      icon: "/assets/images/contact_us/call.png",
      title: "Call us directly",
      descn: `+91 ${appsetup?.contact_no}`,
    },
  ];

  const [successmodal, setSuccessmodal] = useState(false);
  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onSubmit = async (data) => {
    const res = await dispatch(contactusForm(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setSuccessmodal(true);
      setTimeout(() => {
        setSuccessmodal(false);
      }, 2000);
      reset();
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  useEffect(() => {
    dispatch(appSetup());
  }, []);

  return (
    <section className="Contact_Us">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="info_main_div">
              <div className="left_info_div">
                {data?.map((item) => {
                  return (
                    <div className="info_holder">
                      <img
                        src={process.env.PUBLIC_URL + item?.icon}
                        className="icon_img"
                      />
                      <p className="title_text">{item?.title}</p>
                      <p className="descn_text">{item?.descn}</p>
                    </div>
                  );
                })}
              </div>

              <div className="specs_img_div">
                <img
                  src="/assets/images/contact_us/img1.png"
                  className="specs_img"
                />
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="contact_form">
              <p className="form_title">Let's get in touch</p>

              <Form>
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="What's your good name"
                    {...register("name", {
                      required: "Name is required",
                    })}
                  />
                  {errors?.name && (
                    <sup className="text-danger">{errors?.name?.message}</sup>
                  )}
                </Form.Group>

                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your email address"
                    {...register("email", {
                      required: "Email address is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors?.email && (
                    <sup className="text-danger">{errors?.email?.message}</sup>
                  )}
                </Form.Group>

                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Contact Number</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    placeholder="Enter mobile number"
                    {...register("number", {
                      required: "Mobile Number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                        message: "Enter valid 10-digit mobile number",
                      },
                    })}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault(); // blocks non-numeric input
                      }
                    }}
                  />
                  {errors?.number && (
                    <sup className="text-danger">{errors?.number?.message}</sup>
                  )}
                </Form.Group>

                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Your message</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    type="text"
                    placeholder="Enter your message"
                    {...register("message", {
                      required: "Provide your thouths is required",
                    })}
                  />
                  {errors?.message && (
                    <sup className="text-danger">
                      {errors?.message?.message}
                    </sup>
                  )}
                </Form.Group>

                <Form.Group
                  className="input_group check_div"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Check
                    type="checkbox"
                    label="I agree with the"
                    className="mini-text"
                    {...register("terms", {
                      required: "You must accept the Terms & Conditions",
                    })}
                  />

                

                  <Link to="/terms-conditions">
                    <p className="bold_text">Terms & Conditions</p>
                  </Link>
                </Form.Group>
                  {errors.terms && (
                    <p className="text-danger small">{errors.terms.message}</p>
                  )}
                

                <div className="btn_holder">
                  <Explore_btn
                    name={"Send Message"}
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <MapComponent lat={appsetup?.lat} lng={appsetup?.long} />

      {/* <div className="map_div">
        <div className={"map"}>
          <iframe
            className="gmap_iframe"
            frameBorder="0"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15133.39075304903!2d73.7810866!3d18.5131838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1719574302642!5m2!1sen!2sin"
            title="Google Map"
          ></iframe>
        </div>
      </div> */}

      <Newslater />

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Form Submited Successfully !"}
      />
       <Chat_Bot_Contact product={product}/>
    </section>
  );
};

export default Contact_Us;
